import { render, staticRenderFns } from "./AgreementModal.vue?vue&type=template&id=5e72d8c4&scoped=true"
import script from "./AgreementModal.vue?vue&type=script&lang=ts"
export * from "./AgreementModal.vue?vue&type=script&lang=ts"
import style0 from "./AgreementModal.vue?vue&type=style&index=0&id=5e72d8c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72d8c4",
  null
  
)

export default component.exports